import React from "react";

const AboutJourneySection = ({ data }) => (

    <section
        className="student-journey-section"
        id="journey"
    >

        <div className="container">

            <div className="student-section-header">

                <span className="student-eyebrow">
                    {data.eyebrow}
                </span>

                <h2>
                    {data.title}
                    <span>{data.highlight}</span>
                </h2>

                <p>
                    {data.description}
                </p>

            </div>


            <div className="student-journey-grid">

                {(data.steps || []).map((item, i) => (

                    <div
                        className="student-journey-card"
                        key={i}
                    >

                        <div className="student-step">
                            {item.step}
                        </div>

                        <h3>
                            {item.title}
                        </h3>

                        <p>
                            {item.description}
                        </p>

                    </div>

                ))}

            </div>

        </div>

    </section>
);

export default AboutJourneySection;